import React from 'react';
import LoginForm from "../../../Components/LoginForm";
import ResetPassword from "../../Passwords/ResetPassword";

export default function Login() {
    const [knowsPassword, setKnowsPassword] = React.useState(true);

    return (
        <>
            {knowsPassword ?
                <LoginForm setKnowsPassword={setKnowsPassword} />
                :
                <ResetPassword setKnowsPassword={setKnowsPassword} />
            }
        </>
    );
}
